import React from "react";
import { useGame } from "@/contexts/GameContext";
import StartScreen from "@/components/screens/StartScreen";
import ConfigScreen from "@/components/screens/ConfigScreen";
import GameScreen from "@/components/screens/GameScreen";
import EndScreen from "@/components/screens/EndScreen";
import SettingsScreen from "@/components/screens/SettingsScreen";
import { AnimatePresence, motion } from "framer-motion";
import ShopScreen from "./components/screens/ShopScreen";

export default function GameApp() {
  const { state } = useGame();

  console.log("🎮 GameApp - Zmiana ekranu:", state.screen);

  const renderScreen = () => {
    console.log("🔄 Renderowanie ekranu:", state.screen);
    switch (state.screen) {
      case "start":
        return <StartScreen />;
      case "config":
        return <ConfigScreen />;
      case "game":
        return <GameScreen />;
      case "end":
        return <EndScreen />;
      case "settings":
        return <SettingsScreen />;
      case "shop":
        return <ShopScreen />;
      default:
        console.log("⚠️ Nieznany ekran, powrót do start:", state.screen);
        return <StartScreen />;
    }
  };

  // Definicja animacji (możesz ją dostosować)
  const screenVariants = {
    initial: {
      opacity: 0,
    },
    in: {
      opacity: 1,
      transition: {
        type: "spring", // Możesz eksperymentować (tween, spring)
        stiffness: 100,
        damping: 15,
        duration: 0.15,
      },
    },
    out: {
      opacity: 0,
      transition: {
        type: "tween",
        ease: "easeInOut",
        duration: 0.15,
      },
    },
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={state.screen}
        variants={screenVariants}
        initial="initial"
        animate="in"
        exit="out"
        className="min-h-screen container py-4 h-full flex flex-col max-w-xl"
      >
        {renderScreen()}
      </motion.div>
    </AnimatePresence>
  );
}
